import { render, staticRenderFns } from "./IconScgTraForkKnifeDrk.vue?vue&type=template&id=b60ae3da&scoped=true&"
import script from "./IconScgTraForkKnifeDrk.vue?vue&type=script&lang=js&"
export * from "./IconScgTraForkKnifeDrk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60ae3da",
  null
  
)

export default component.exports